"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS_CONSTANTS = exports.css = void 0;
/**
 * CSS Template Literal Helper Function
 *
 * This function provides type-safe CSS-in-JS functionality by processing tagged template literals.
 * It mimics the behavior of libraries like styled-components but in a lightweight, dependency-free way.
 *
 * @param styles - TemplateStringsArray containing the static string parts of the template literal
 * @param values - Rest parameter capturing any interpolated values (variables) in the template
 * @returns Complete CSS string with interpolated values inserted at correct positions
 *
 * Example usage:
 *   const color = "#ff0000";
 *   const margin = 8;
 *   const cssString = css`
 *     color: ${color};
 *     margin: ${margin}px;
 *     background: blue;
 *   `;
 *   // Returns: "color: #ff0000; margin: 8px; background: blue;"
 */
const css = (styles, ...values) => {
    return styles.reduce((result, style, index) => {
        return result + style + (values[index] || "");
    }, "");
    // TODO: If we want to enhance things.
    // const rawCSS = styles.reduce((result, style, index) => {
    //     return result + style + (values[index] || "");
    // }, "");
    // const isDevelopment = process.env.NODE_ENV !== 'production';
    // if (isDevelopment) {
    //     // Optional: Pretty print in development
    //     return rawCSS
    //         .replace(/\s+/g, ' ')      // Normalize whitespace
    //         .replace(/;\s*/g, ';\n')   // Line breaks after semicolons
    //         .trim();
    // }
    // // Production: minified (remove unnecessary whitespace, preserve comments)
    // return rawCSS
    //     .replace(/\s+/g, ' ')         // Normalize whitespace
    //     .replace(/\s*;\s*/g, ';')     // Remove spaces around semicolons
    //     .replace(/\s*{\s*/g, '{')     // Remove spaces around braces
    //     .replace(/\s*}\s*/g, '}')
    //     .trim();
};
exports.css = css;
exports.CSS_CONSTANTS = {
    // Colors
    COLORS: {
        USAGE_NEUTRAL_LIGHT_BG: "#f3f3f4",
        USAGE_NEUTRAL_DARK_TEXT: "#3f3e51",
        USAGE_NEUTRAL_BASIC_TEXT: "#3f3E51",
        USAGE_NEUTRAL_ICON: "#585867",
    },
    BREAKPOINTS: {
        MOBILE: 390,
        TABLET: 768, // pixels
        // DESKTOP: 1024, // pixels
    },
};
//# sourceMappingURL=css-in-js.js.map